@if (message().reportStatus === 'COMPLETED' && message().reportSummary; as summary) {
  <div class="report-result">
    <div class="report-result__body">
      <strong class="report-result__title">
        <svg class="report-result__icon report-result__icon--success" viewBox="0 0 16 16" aria-hidden="true">
          <rect x="1" y="1" width="14" height="14" rx="2" fill="currentColor" />
          <path d="m4.5 8 2.3 2.3 4.7-4.7" fill="none" stroke="#fff" stroke-width="1.8"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        ¡Reporte generado exitosamente!
      </strong>
      <div class="report-result__section">
        <strong>Resumen:</strong>
        <span><strong>Vehículo:</strong> {{ summary.vehicleLicensePlate }}</span>
        <span><strong>Fecha:</strong> {{ summary.reportDate | date:'dd/MM/yyyy':'UTC' }}</span>
      </div>
      <p class="report-result__total"><strong>Monto total:</strong>
        {{ currencyLabel(summary.currency) }}{{ summary.totalAmount | number:'1.2-2' }}</p>
      @for (method of summary.paymentMethods; track $index) {
        <div class="report-result__method">
          <strong>{{ method.category }}:</strong>
          <span class="report-result__method-metrics">
            <span class="report-result__metric"><span aria-hidden="true">#️⃣</span> {{ method.totalTransactions }}</span>
            <span class="report-result__metric"><span aria-hidden="true">💰</span> {{ currencyLabel(summary.currency) }}{{ numericAmount(method.totalAmount) | number:'1.2-2' }}</span>
          </span>
        </div>
      }
      @if (message().reportUrl) {
        <p class="report-result__download">
          <svg class="report-result__icon report-result__icon--link" viewBox="0 0 20 20" aria-hidden="true">
            <path d="m8 12 4-4M7.2 14.2l-1.4 1.4a3 3 0 0 1-4.2-4.2l4.2-4.2A3 3 0 0 1 10 7m0 6a3 3 0 0 0 4.2 0l4.2-4.2a3 3 0 0 0-4.2-4.2l-1.4 1.4"
              fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span>Descarga tu reporte <a [href]="message().reportUrl" target="_blank"
            rel="noopener noreferrer">aquí</a>.</span>
        </p>
      }
    </div>
    <p class="report-result__notice">
      <svg class="report-result__icon report-result__icon--warning" viewBox="0 0 18 18" aria-hidden="true">
        <path d="M9 1.7 17 16H1L9 1.7Z" fill="currentColor" />
        <path d="M9 6.2v5.1M9 13.5v.2" fill="none" stroke="#65450e" stroke-width="1.6"
          stroke-linecap="round" />
      </svg>
      <span><strong>Importante:</strong> Este enlace estará disponible por 48 horas</span>
    </p>
  </div>
} @else {
  <p class="report-result__failure">No pudimos generar tu reporte. Inténtalo nuevamente.</p>
}
